<div class="celo-page">
  <div class="celo-content page">
    <div class="text">You do not have the required access to view this page. Please contact us at <a href="mailto:support@celohealth.com" class="celo-link">support@celohealth.com</a>.</div>
    <button mat-button class="celo-primary-button" (click)="logout()">Logout</button>
  </div>
</div>